module.exports = __webpack_public_path__ + "static/media/no-option-selected.0447abd0.svg";